import './index.css';

export default {
  name: 'AseamlessScrollList',
  props: {
    id: { type: String, default: () => (`a-seamless-scroll-list-${Math.random().toString().substring(2)}`) },
    speed: { type: Number | String, default: () => 1000 }, // 滚动速度(值越小越快)
    pause: { type: Boolean, default: () => false }, // 是否暂停
    data: { type: Array, default: () => null },
    items: { type: Array, default: () => null },
    config: { type: Array, default: () => null },
    option: { type: Array, default: () => null },
    options: { type: Array, default: () => null },
  },
  data() {
    return ({
      list: this.options || this.option || this.config || this.items || this.data || [],
      stop: this.pause,
      itemHeight: null,
      height: null,
      position: null,
      animation: null,
    });
  },
  watch: {
    data: { deep: true, immadiate: true, handler() { this.create() } },
    items: { deep: true, immadiate: true, handler() { this.create() } },
    config: { deep: true, immadiate: true, handler() { this.create() } },
    option: { deep: true, immadiate: true, handler() { this.create() } },
    options: { deep: true, immadiate: true, handler() { this.create() } },
    pause(state) {
      this.stop = state;
      this.$nextTick(() => this.enable());
    },
  },
  computed: {
    style() {
      return ({ transform: (`translateY(${-this.position}px)`) });
    },
    array() {
      return (this.position >= this.height ? this.list : [...this.list, ...this.list]);
    },
  },
  mounted() {
    this.create();
  },
  destroyed() {
    this.revoke();
  },
  methods: {
    create() {
      this.$nextTick(() => {
        const body = this.$el.querySelector('.a-seamless-scroll-list-body');
        if (body) {
          !this.height && (this.height = body.clientHeight);
          this.$nextTick(() => {
            !this.itemHeight && (this.itemHeight = (this.height / this.list.length));
            this.$nextTick(() => this.enable());
          });
        }
      });
    },
    moving() {
      this.position += Math.min((1000 / parseInt(this.speed)), 5);
      if (this.position >= this.height) {
        this.position = 0;
      }
      this.$nextTick(() => this.$emit('moving', this.position));
    },
    enable() {
      if (this.animation) {
        this.cancel();
      } else if (this.stop === false) {
        const animation = () => {
          this.moving();
          this.$nextTick(() => this.animation = requestAnimationFrame(animation));
        }
        animation();
      }
    },
    cancel() {
      if (this.animation) {
        cancelAnimationFrame(this.animation);
        this.animation = null;
      }
    },
    revoke() {
      this.cancel();
      this.$nextTick(() => {
        this.position = null;
        this.height = null;
      });
    },
    locate(a) {
      return parseInt((((this.itemHeight * a) - this.position) * 4) / 100);
    },
    click(a, b, c) {
      this.$emit('click', a, b, c);
      this.$emit('select', a, b, c);
      this.$emit('choose', a, b, c);
    },
  },
  render() {
    const { width = '100%', height = '100%', padding, margin } = this.$attrs;
    return (
      <div class="a-seamless-scroll-list" id={this.id} style={{ width, height, padding, margin }} on-mouseenter={this.cancel} on-mouseleave={this.enable}>
        <div class="a-seamless-scroll-list-body" style={this.style}>
          {this.array && this.array.length > 0 && (this.array.map((a, b) => {
            const label = a.label || a.title || a.text || a.name || a;
            const element = a.components || a.component || a.formatter || a.element || a.format || a.render || a.dom || null;
            return (
              <div
                key={b}
                on-click={(c) => this.click(a, b, c)}
                style={{ opacity: (this.locate(b) > 15 ? 0 : null) }}
                class={['a-seamless-scroll-list-item', (`item-${this.locate(b)}`), (b % 2 === 0 ? 'base' : 'even')]}
              >
                {element || label}
              </div>
            );
          }))}
        </div>
      </div>
    );
  },
}